module.exports = __webpack_public_path__ + "static/media/card-1.6143c806.jpeg";